import { Flight } from "../../../../models/flight.model";
import { amount, flag } from "../../../form/controls";

export function passengersControls(flight: Flight) {
    return {
        passengers: amount(flight.passengers),
        payingPassengers: amount(flight.payingPassengers),
        isTax: flag(flight.isTax),
    };
}
